import {
  HttpClient,
  HttpBackend,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportFiltersService {
  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,

    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
    this.token = localStorage.getItem("currentClient");
  }

  token: string;

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  getApprovedGroups(payload): Observable<any> {
    return this.http
      .get("/api/group/approved-group-list", {
        params: payload,
      })
      .pipe(catchError(this.handleError));
  }
  getFinancialYears(): Observable<any> {
    return this.http
      .get("/api/financialYear/financialYear")
      .pipe(catchError(this.handleError));
  }

  getReports(url, params): Observable<any> {
    let options = {
      headers: new HttpHeaders({ "Content-Type": "application/JSON" }),
      responseType: "arraybuffer" as "json",
      //observe: 'response'
    };

    return this.http
      .get("/api/report/" + url, {
        params: params,
        ...options,
      })
      .pipe(catchError(this.handleError));
  }
}
